import {
  BathroomConfigurationState,
  HandleType,
  ValidationError,
  ValidationResult,
  ValidationRule,
} from 'src/app/models/configurators-2d/mobile/bathroom/bathroom-validation.models';

const MIN_FIRST_ROW_WIDTH = 60;
const MAX_OFFSET_LENGTH = 0.5;

/**
 * Règles de validation communes à toutes les gammes
 */
export const COMMON_RULES: ValidationRule[] = [
  {
    id: 'min_first_row_width',
    name: 'Largeur minimum première ligne',
    description: 'La première ligne doit avoir une largeur minimum de 60cm',
    validate: (state: BathroomConfigurationState): ValidationResult => {
      const firstRow = state.composition?.compositionConfiguration?.rows?.find(r => r.index === 0);
      if (!firstRow || !firstRow.columns) {
        return { valid: true, errors: [] };
      }

      const totalWidth = firstRow.columns.reduce((sum, col) => sum + col.width, 0);

      if (totalWidth < MIN_FIRST_ROW_WIDTH) {
        return {
          valid: false,
          errors: [
            {
              code: 'MIN_FIRST_ROW_WIDTH',
              message: `La largeur de la première ligne (${totalWidth}cm) est inférieure au minimum requis (${MIN_FIRST_ROW_WIDTH}cm)`,
              field: 'columnWidth',
              rowIndex: 0,
            },
          ],
        };
      }

      return { valid: true, errors: [] };
    },
  },
  {
    id: 'offset_max_value',
    name: 'Offset maximum',
    description: "L'offset ne peut pas dépasser 50% de la largeur de la ligne",
    validate: (state: BathroomConfigurationState): ValidationResult => {
      const errors: ValidationError[] = [];

      state.rowConfigurations.forEach(rowConfig => {
        if (rowConfig.rowIndex === 0) return;

        const row = state.composition?.compositionConfiguration?.rows?.find(r => r.index === rowConfig.rowIndex);

        if (!row) return;

        const maxOffset = row.width * MAX_OFFSET_LENGTH;

        if (rowConfig.offset > maxOffset) {
          errors.push({
            code: 'OFFSET_EXCEEDED',
            message: `L'offset (${rowConfig.offset}cm) ne peut pas dépasser ${maxOffset}cm`,
            field: 'offset',
            rowIndex: rowConfig.rowIndex,
          });
        }
      });

      return {
        valid: errors.length === 0,
        errors,
      };
    },
  },
  {
    id: 'handle_to_fix_requires_length',
    name: 'Poignée à fixer nécessite une longueur',
    description: 'Si le type de poignée est "à fixer", une longueur doit être sélectionnée',
    validate: (state: BathroomConfigurationState): ValidationResult => {
      const handleConfig = state.handleConfiguration;

      if (handleConfig.handleType !== HandleType.ToFix) {
        return { valid: true, errors: [] };
      }

      const errors: ValidationError[] = [];

      if (!handleConfig.handleLength) {
        errors.push({
          code: 'HANDLE_LENGTH_REQUIRED',
          message: 'Veuillez sélectionner une longueur de poignée',
          field: 'handleLength',
        });
      }

      if (!handleConfig.handleFinitionId) {
        errors.push({
          code: 'HANDLE_FINITION_REQUIRED',
          message: 'Veuillez sélectionner une finition de poignée',
          field: 'handleFinition',
        });
      }

      return {
        valid: errors.length === 0,
        errors,
      };
    },
  },
];
